

















































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { userModule } from "@/store/modules/user";
import moment from "moment";
import SvcRekonsiliasiObat from "@/services/RekonsiliasiObat";
import { appModule } from "@/store/modules/app";
import storeReferensiUnit from "@/store/modules/new/ReferensiUnit";

interface DataRekonsiliasiObat {
  id: number | null;
  register_id: string;
  pasien_rm: string;
  category: string;
  asal_unit_id: string;
  tujuan_unit_id: string;
  user_id: string;
  dokter_id: number | null;
  detail: any[];
}

@Component({
  components: {},
  inject: { isReadOnly: { default: () => () => false } }
})
export default class ModalRekonsiliasiObatTransfer extends Vue {
  @Prop() readonly value!: boolean;
  @Prop() readonly register;
  @Prop() readonly rm;
  @Prop({ required: true }) rekonsiliasiObat!: DataRekonsiliasiObat;

  isReadOnly!: () => boolean;
  get readOnly(): boolean {
    return this.isReadOnly();
  }

  saving = false;
  mounted() {}

  get dialog() {
    return this.value;
  }

  set dialog(value) {
    this.$emit("input", value);
  }

  @Watch("value")
  changeValue(val) {}

  close() {
    this.dialog = false;
  }
  save() {
    if (this.readOnly) return;
    if (!this.saving) {
      this.saving = true;
      const save = this.rekonsiliasiObat.id
        ? SvcRekonsiliasiObat.update(
            this.rekonsiliasiObat.id,
            this.rekonsiliasiObat
          )
        : SvcRekonsiliasiObat.create(this.rekonsiliasiObat);
      save
        .then((resp: any) => {
          if (resp.status === 1) {
            appModule.NoticeDelay("Berhasil menambahkan Rekonsiliasi Obat");
            this.$emit("reload");
            this.dialog = false;
          } else {
            appModule.sendErrorAlert(resp.message);
          }
        })
        .finally(() => {
          this.saving = false;
        });
    }
  }

  get listUnitRanap() {
    return storeReferensiUnit.unit;
  }

  onChangeUnitAsal(val: any) {
    this.rekonsiliasiObat.asal_unit_id = val ? val.id : null;
  }

  onChangeUnitTujuan(val: any) {
    this.rekonsiliasiObat.tujuan_unit_id = val ? val.id : null;
  }
}
